import { RegionConfig } from './RemoteConfig'
import { DiscountRules } from './strapi'

export type NotificationType = 'paylink' | 'purchase-confirmation'

export type NotificationDeliveryMethod =
  | 'sparkpost:email'
  | 'bird:mobile:sms'
  | 'bird:mobile:whatsapp'

export type NotificationConfigTemplate = {
  id: number
  name: string
  subject: string
  htmlContent: string
  sender: {
    name: string
    email: string
    id: string
  }
}

export type NotificationConfig = {
  id: number
  name: string
  notificationType: NotificationType
  deliveryMethod: NotificationDeliveryMethod
  templateId: string
  template?: NotificationConfigTemplate | null
  variables?: Array<{ key: string; value: string }>
  region?: {
    id: number
    countryCode: string
    notificationChannelConfig?: {
      id: number
      birdWorkspaceId: string
      birdWhatsappChannelId?: string | null
      birdSmsChannelId?: string | null
      emailSenderName: string
      emailSenderEmail: string
    } | null
  } | null
}

export type RemoteServerConfig = {
  region: RegionConfig
  discountRules: DiscountRules.Rule[]
  notificationConfigs?: NotificationConfig[]
}
